import { SP } from "./namespace";
import { clamp, SPELLS, SPELL_ORDER } from "../client";
SP.ids = new Set(SPELL_ORDER);
SP.has = (id) => SP.ids.has(id);
// was SPELL_PREVIEW_IDS = new Set(SPELL_ORDER);

SP.PREVIEW_W = 544;
SP.PREVIEW_H = 304;

SP.PREVIEW_CFG = {
  w: SP.PREVIEW_W, h: SP.PREVIEW_H, loop: 2.9,
  cx: 272, cy: 164, platformR: 124, playerR: 30,
  casterX: 148, targetX: 396, y: 164,
  spawnX: 188, hitX: 372,
  casterRobe: 0, targetRobe: 2,
  castAt: 0.5, flyStart: 0.66,
};

SP.loopFor = function(spellId) {
  const s = SPELLS[spellId];
  if (!s) return 2.9;
  if (s.windup && s.windup >= 1.2) return 3.5;
  if (s.type === "blizzard" || (s.duration && s.duration >= 4)) return 3.5;
  if (s.fall || s.type === "voidrip" || s.type === "snare") return 3.2;
  if (s.type === "illusion") return 3.1;
  if (spellId === "reflect") return 3.3;
  return 2.9;
}

SP.flySpeed = function(spellId, s) {
  if (s.fall) return 95;
  if (s.speed) return clamp(s.speed * 0.2, 65, 150);
  return 110;
}
SP.CAPTION = {
  scourge: "Channel → blast (also damages you)",
  frostnova: "Instant ring — freezes nearby enemies",
  lightning: "Instant bolt to nearest foe in aim",
  voidbeam: "Hold to charge a line beam (self slow + exhaustion)",
  chain: "Arcs through several nearby targets",
  blizzard: "Ground blizzard — damage inside zone",
  windwalk: "Invisible rush — slam on contact",
  illusionist: "Spawns decoy copies of you",
  teleport: "Blink toward cursor",
  thrust: "Dash forward — slams on hit",
  gravity: "Black hole pulls enemies inward",
  snare: "Ground rune — roots/chills inside",
  voidrip: "Center rip — pulls everyone in; core hurts you too",
  firewall: "Wall of fire blocks a lane",
  swap: "Projectile swaps positions on hit",
  meteor: "Meteor falls — big AoE blast",
  frozenorb: "Slow orb sprays frost spikes",
  homing: "Projectile homes on target",
  boomerang: "Curves out and returns",
  bouncer: "Ricochets off walls and foes",
  firespray: "Fan of firebolts",
  splitter: "Bursts into shards on impact",
  timeshift: "Rewind position and HP",
  rush: "Move faster, less knockback",
  shield: "Knockback immunity bubble",
  barrier: "Ward soaks damage",
  reflect: "Bounces projectiles back",
};
SP.captionFor = (id) => SP.CAPTION[id] || "";

